import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SvgIconComponent } from '../../../shared/components/svg-icon/svg-icon.component';

import { ITokenPlan } from '../../../shared/interfaces/token.interfaces';
import { ISvgConfig } from '../../../shared/interfaces/svg.interfaces';

import { ETokenPlan } from '../../../shared/enums/tokens.enums';
import { ESvgTypes } from '../../../shared/enums/svg.enums';

@Component({
  selector: 'stxt-tokens-plan-card',
  standalone: true,
  imports: [CommonModule, SvgIconComponent],
  templateUrl: './tokens-plan-card.component.html',
  styleUrl: './tokens-plan-card.component.scss'
})
export class TokensPlanCardComponent {
  @Input() plan: ITokenPlan;
  @Input() selectedPlan: string;
  tokensSvg: ISvgConfig = { name: 'token-star', fill: ESvgTypes.None };

  getPlanIcon(planName: ETokenPlan): string {
    const planIcons: { [key in ETokenPlan]: string } = {
      [ETokenPlan.Popular]: '🔥',
      [ETokenPlan.Basic]: '🌟',
      [ETokenPlan.Starter]: '⭐️',
      [ETokenPlan.Premium]: '💎'
    };

    return planIcons[planName] || '';
  }
}
